import * as React from 'react';
import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import { GetCityList } from '../../services/apiServices/PostServices';
import { showToast } from '../constants/Toaster';
import { Popper } from '@mui/material';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const statusData = [
    {
        id: 1,
        name: "Active",
        status: 1
    },
    {
        id: 2,
        name: "Disable",
        status: 0
    }
]

export const CustomMutilevelDropdown = (props) => {
    const [open, setOpen] = React.useState(false);
    const [roleName, setRoleName] = React.useState("");
    const [investmentType,setInvestmentType]=useState("");
    const [roleId, setRoleId] = React.useState("")
    const [status, setStatus] = React.useState("");
    const [statusId, setStatusId] = React.useState("")
    const [cityName, setCityName] = React.useState([]);
    const [cityId, setCityId] = React.useState([]);
    const [stateName, setStateName] = React.useState([]);
    const [stateId, setStateId] = React.useState([]);
    const [serviceId, setServiceId] = React.useState([]);
    const [serviceName, setServiceName] = React.useState([]);
    const [filtersApplied, setFiltersApplied] = React.useState(false)
    const [cityListData, setCityListData] = React.useState([])
    const [value, setValue] = useState([null, null]);
    const roleData = props?.userType
    const cityData = props?.cityData
    const serviceData = props?.serviceData
    const statesData = props?.stateData

    useEffect(() => {
        if (stateId.length !== 0 && stateId.length === 1) {
            callCitylistApi()
        } else {
            setCityListData([])
        }
    }, [stateId]);

    const investment_type= [
        {
            id:"1",
            name:"Type 1"
        },
        {
            id:"2",
            name:"Type 2"
        },
        {
            id:"3",
            name:"Type 3"
        },
    ]

    useEffect(() => {
        if (props?.toggle !== undefined) {
            setFiltersApplied(false)
            setRoleName("")
            setStatus("")
            setStateName([])
            setStateId([])
            setCityName([])
            setCityId([])
            setRoleId("")
            setStatusId("")
            setServiceId([])
            setServiceName([])
        }
    }, [props?.toggle]);


    //function call to open filter
    const handleClickOpen = () => {
        setOpen(true);
    };

    //function call to close filer
    const handleClose = (event, reason) => {
        if (reason !== 'backdropClick') {
            if (filtersApplied === false) {
                setRoleName("")
                setStatus("")
                setStateName([])
                setStateId([])
                setCityName([])
                setCityId([])
                setRoleId("")
                setStatusId("")
                setServiceId([])
                setServiceName([])
            }
            setOpen(false);

        }
    };


    //function to call city api
    const callCitylistApi = async () => {
        const reqbody = {
            state_id: stateId[0]
        }
        const res = await GetCityList(`city`, reqbody)
        if (res?.success) {
            setCityListData(res?.data)
        } else {
            console.log("res", res?.message)
        }
    }
    const reqbody1 = {
        role: roleId,
        city: cityId,
        state: stateId,
        is_active: statusId
    }

    const reqbody2 = {
        type: serviceId,
        city: cityId,
        state: stateId,
        is_active: statusId
    }

    //function call to apply filters
    const handleFilterApply = () => {
        if (roleId.length === 0 && serviceId.length === 0 && stateId.length === 0 && cityId.length === 0 && statusId === "") {
            showToast(2, "Please select any option")
        }
        else if ((roleId !== "" || serviceId !== "") || stateId.length !== 0 || cityId.length !== 0 || statusId !== "") {
            props?.reqBody(props?.from === "Store Management" ? reqbody2 : reqbody1)
            setFiltersApplied(true)
            // setCityListData([])
            setOpen(false)
        }
    }


    const CustomPopper = (props) => (
        <Popper
          {...props}
          sx={{
            width: '300px', // Adjust the popper width
            '& .MuiCalendarPicker-root': {
              width: '100%', // Ensures the calendar takes the full width of the popper
              height: '200px', // Adjust the calendar height
            },
            '& .MuiDayPicker-day': {
              width: '30px', // Adjust day cell width
              height: '30px', // Adjust day cell height
            },
          }}
        />
      );

    //function call to on change role
    const handleChange = (event) => {
        const {
            target: { value },
        } = event;
        setRoleName(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    const handleChnageInvestment = (event) => {
        const {
            target: { value },
        } = event;
        setInvestmentType(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    }

    //function call to on change role
    const handleServiceChange = (event) => {
        const {
            target: { value },
        } = event;
        setServiceName(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };


    //function call to onchange status
    const handleChangeStatus = (event) => {
        const {
            target: { value },
        } = event;
        setStatus(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };
    //function call to clear filter
    const handleClear = () => {
        props?.clear()
        setRoleName("")
        setStatus("")
        setStateName([])
        setStateId([])
        setCityName([])
        setCityId([])
        setRoleId("")
        setStatusId("")
        setServiceId([])
        setServiceName([])
        setCityListData([])
        setFiltersApplied(false)
    }

    const handleStateId = (id) => {
        let newSelectedIds = [...stateId]
        if (!stateId.includes(id)) {
            // Add the ID to the array if checked
            newSelectedIds = [...newSelectedIds, id];
            setStateId(newSelectedIds)
        } else {
            // Remove the ID from the array if unchecked
            newSelectedIds = newSelectedIds.filter((selectedId) => selectedId !== id);
            setStateId(newSelectedIds)
        }
    }

    const handleCityId = (id) => {
        let newSelectedIds = [...cityId]
        if (!cityId.includes(id)) {
            // Add the ID to the array if checked
            newSelectedIds = [...newSelectedIds, id];
            setCityId(newSelectedIds)
        } else {
            // Remove the ID from the array if unchecked
            newSelectedIds = newSelectedIds.filter((selectedId) => selectedId !== id);
            setCityId(newSelectedIds)
        }
    }

    const handleServiceId = (id) => {
        let newSelectedIds = [...serviceId]
        if (!serviceId.includes(id)) {
            // Add the ID to the array if checked
            newSelectedIds = [...newSelectedIds, id];
            setServiceId(newSelectedIds)
        } else {
            // Remove the ID from the array if unchecked
            newSelectedIds = newSelectedIds.filter((selectedId) => selectedId !== id);
            setServiceId(newSelectedIds)
        }
    }

    //function call to onchange city
    const handleChangeCity = (event) => {
        const {
            target: { value },
        } = event;
        setCityName(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    //function call to onchange city
    const handleChangeState = (event) => {
        const {
            target: { value },
        } = event;
        setStateName(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
        //setCityId("")
        setCityName([])
    };

    return (
        <div>
            <div class="d-flex pointer">
                <div class="d-flex" onClick={handleClickOpen}>
                    <h6 class="secondColor d-flex justify-content-center align-items-center fw-bold mx-2 m-0">
                        Filter
                    </h6>

                    <i class="bi bi-funnel colorPrimary"></i>
                    {
                        filtersApplied ?
                            <span style={{ width: "5px", height: "5px", backgroundColor: "red", borderRadius: "25px" }}></span> : null
                    }
                </div>
                {filtersApplied ?
                    <div class="border rounded mx-2 ">
                        <h6 class="colorOrange fw-bold mx-2 m-0" onClick={handleClear}>Clear</h6>
                    </div>

                    : null
                }
            </div>
           
                    <Dialog disableEscapeKeyDown open={open} onClose={handleClose}>
                        <DialogTitle sx={{ marginLeft: "20px" }}  >Filter</DialogTitle>
                        <DialogContent>
                            <Box component="form" sx={{ display: 'flex', flexWrap: 'wrap', marginLeft: "10px" }}>
                                {
                                    props?.from === "Store Management" ?
                                        <FormControl sx={{ m: 1, width: 250 }}>
                                            <InputLabel id="role">Store Category</InputLabel>
                                            <Select
                                                labelId="StoreCategory"
                                                id="StoreCategory"
                                                multiple
                                                value={serviceName}
                                                onChange={handleServiceChange}
                                                input={<OutlinedInput label="Store Category" />}
                                                renderValue={(selected) => selected.join(', ')}
                                                MenuProps={MenuProps}
                                            >
                                                {serviceData.map((name) => (
                                                    <MenuItem key={name.type} value={name.name} onClick={() => handleServiceId(name.id)}>
                                                        <Checkbox checked={serviceName.indexOf(name.name) > -1} />

                                                        <ListItemText primary={name.name} />
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl> :
                                        <FormControl sx={{ m: 1, width: 250 }}>

                                            <InputLabel id="role">Role</InputLabel>
                                            <Select
                                                labelId="role"
                                                id="Role"
                                                // multiple
                                                value={roleName}
                                                onChange={handleChange}
                                                input={<OutlinedInput label="Role" />}
                                                renderValue={(selected) => selected.join(', ')}
                                                MenuProps={MenuProps}
                                            >
                                                {roleData.map((name) => (
                                                    <MenuItem key={name.id} value={name.name} onClick={() => setRoleId(name.id)}>
                                                        <Checkbox checked={roleName.indexOf(name.name) > -1} />
                                                        <ListItemText primary={name.name} />
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>

                                }

                                <FormControl sx={{ m: 1, width: 250 }}>
                                    <InputLabel id="status">Status</InputLabel>
                                    <Select
                                        labelId="status"
                                        id="Status"
                                        // multiple
                                        value={status}
                                        onChange={handleChangeStatus}
                                        input={<OutlinedInput label="Status" />}
                                        renderValue={(selected) => selected.join(', ')}
                                        MenuProps={MenuProps}
                                    >
                                        {statusData.map((name) => (
                                            <MenuItem key={name.id} value={name.name} onClick={() => setStatusId(name.status)}>
                                                <Checkbox checked={status.indexOf(name.name) > -1} />
                                                <ListItemText primary={name.name} />
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <FormControl sx={{ m: 1, width: 250 }}>
                                    <InputLabel id="status">State</InputLabel>
                                    <Select
                                        labelId="State"
                                        id="State"
                                        multiple
                                        value={stateName}
                                        onChange={handleChangeState}
                                        input={<OutlinedInput label="State" />}
                                        renderValue={(selected) => selected.join(', ')}
                                        MenuProps={MenuProps}
                                    >
                                        {statesData.map((name) => (
                                            <MenuItem key={name.id} value={name.name} onClick={() => handleStateId(name.id)} >
                                                <Checkbox checked={stateName.indexOf(name.name) > -1} />
                                                <ListItemText primary={name.name} />
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <FormControl sx={{ m: 1, width: 250 }}>
                                    <InputLabel id="status">City</InputLabel>
                                    <Select
                                        labelId="City"
                                        id="City"
                                        multiple
                                        value={cityName}
                                        onChange={handleChangeCity}
                                        input={<OutlinedInput label="City" />}
                                        renderValue={(selected) => selected.join(', ')}
                                        MenuProps={MenuProps}
                                    >
                                        {cityListData.map((name) => (
                                            <MenuItem key={name.id} value={name.name} onClick={() => handleCityId(name.id)}>
                                                <Checkbox checked={cityName.indexOf(name.name) > -1} />
                                                <ListItemText primary={name.name} />
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                {/* <span data-bs-toggle="tooltip" data-bs-placement="top" title={"Multiple select of state could not allow to filter with city"} class="ms-3 paraColore" >Note:- <i class="bi bi-exclamation-circle cursorPointer"></i></span> */}
                            </Box>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleClose}>Cancel</Button>
                            <Button onClick={handleFilterApply}>Apply</Button>
                        </DialogActions>
                    </Dialog>
                    
            

        </div>
    );
}
